package ui.app.assign.detail.kindergarten.editor.page

import androidx.compose.runtime.Composable
import ui.app.assign.detail.kindergarten.KindergartenSummary
import ui.app.assign.detail.kindergarten.editor.AppKindergartenEditorScope
import ui.app.assign.detail.kindergarten.editor.SaveButton

@Composable
fun AppKindergartenEditorScope.KindergartenPage06Summary(nnvl: AppKindergartenEditorScope.Wrapper) {
    KindergartenSummary(nnvl.data, false) {
        SaveButton(this@KindergartenPage06Summary)
    }
}


